import { IErrorResponse } from '../api/errors';
import axios, { axiosClassic } from '../api/intercepors';
import {
  getAdminReviews,
  getComment,
  getLike,
  getReviews,
  setCommentUrl,
} from '../config/url.config';
import {
  ICommentDataResponse,
  ICommentResponse,
  ILikes_info,
  IReview,
  IReviewComment,
  IReviewCommentResponse,
} from '../store/review/review.interface';


export const ReviewService = {
  async addReview({ owner_id, owner_type, content, stars }: IReview) {
    const sessionToken = localStorage.getItem('st');
    return await axios.post<{ review_comment_id: number }>(
      getAdminReviews(''),
      {
        owner_id,
        owner_type,
        content,
        stars,
      },
      {
        headers: { 'session-token': String(sessionToken) },
      }
    );
  },

  async getByCardComment({
    owner_id,
    owner_type,
    limit,
    offset,
  }: IReviewComment) {
    const sessionToken = localStorage.getItem('st');
    const response = await axiosClassic.get<IReviewCommentResponse>(
      getReviews(
        `?owner_id=${owner_id}&owner_type=${owner_type}&limit=${limit}&offset=${offset}`
      ),
      {
        headers: { 'session-token': String(sessionToken) },
      }
    );
    return response.data;
  },
  async addComment(comment_id: number, content: string) {
    const sessionToken = localStorage.getItem('st');
    return await axiosClassic.post<ICommentResponse>(
      setCommentUrl(''),
      { comment_id, content },
      {
        headers: { 'session-token': String(sessionToken) },
      }
    );
  },
  async getComment(comment_id: number, limit = 10, offset = 0) {
    const sessionToken = localStorage.getItem('st');
    return await axiosClassic.get<ICommentDataResponse>(
      getComment(`?comment_id=${comment_id}&limit=${limit}&offset=${offset}`),
      {
        headers: { 'session-token': String(sessionToken) },
      }
    );
  },

  async setLikeOrDislike(comment_id: number, is_like: boolean | null) {
    const sessionToken = localStorage.getItem('st');
    return await axiosClassic.post<
      IErrorResponse & { likes_info: ILikes_info }
    >(
      getLike(``),
      {
        comment_id,
        is_like,
      },
      {
        headers: { 'session-token': String(sessionToken) },
      }
    );
  },
};
